/* eslint-disable */
export default {
  dialPlaceholder: 'Introduzir nome ou número',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
